// extracted by mini-css-extract-plugin
export var people = "people-module--people--2IQhC";